


const displayAudioList:any = [];
const uploadAudioList:any = [];

export const AudioService = {
    displayAudioList,
    uploadAudioList,
  };